import React from 'react';
import { X } from 'lucide-react';
import { NetworkVisualization } from '@/components/NetworkVisualization';

interface DetalhesRedeProps {
  isOpen: boolean;
  onClose: () => void;
}

const DetalhesRede: React.FC<DetalhesRedeProps> = ({ isOpen, onClose }) => {
  const userData = JSON.parse(localStorage.getItem('userlogged') || '{}');

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity duration-300"
        onClick={onClose}
      />

      {/* Bottom Sheet */}
      <div className="fixed inset-x-0 bottom-0 z-50 bg-white rounded-t-2xl shadow-xl animate-in slide-in-from-bottom duration-300 max-h-[95vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Minha Rede</h2>
            <p className="text-sm text-gray-500">Visualize sua rede de indicações</p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="px-4 py-6 pb-12">
          {userData?.id ? (
            <NetworkVisualization usuarioId={userData.id} />
          ) : (
            <p className="text-center text-gray-500 py-8">Usuário não identificado.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default DetalhesRede;
